import { render, staticRenderFns } from "./order.vue?vue&type=template&id=42d81dd9&scoped=true"
import script from "./order.js?vue&type=script&lang=js&external"
export * from "./order.js?vue&type=script&lang=js&external"
import style0 from "./order.css?vue&type=style&index=0&id=42d81dd9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d81dd9",
  null
  
)

export default component.exports